export default __webpack_public_path__ + "static/media/company_2.83a80ae1.jpg";